import { Middleware } from '@reduxjs/toolkit';
import i18n from 'i18next';

import { confirmationTimeout } from '@cashier/cashier-data-access';
import { PaymentTypes, Versions } from '@cashier/cashier-model';
import { eventBus, EventFactory } from '@cashier/cashier-shared';

export const confirmationTimeoutMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === confirmationTimeout.toString()) {
      const {
        cashierConfiguration: { version, currency, paymentType },
        customerInformation: { amount },
        paymentMethod: { paymentMethod },
        paymentProcessing: {
          result: { transactionId },
        },
      } = store.getState();

      if (version === Versions.v3) {
        eventBus.emit(
          EventFactory.paymentProcessed(500, { html: '<html></html>' }), // html payload is necessary to hide the v3 DEPOSIT button
        );
        eventBus.emit(EventFactory.paymentAttributesChanged([]));
      }

      const createPaymentErrorEvent =
        paymentType === PaymentTypes.Withdrawal
          ? EventFactory.withdrawError
          : EventFactory.depositError;

      eventBus.emit(
        createPaymentErrorEvent(
          amount,
          currency,
          paymentMethod.id,
          i18n.t('failedTransaction.message'),
          transactionId,
        ),
      );
    }

    return result;
  };
